module.exports = __webpack_public_path__ + "img/-.172fdd14.svg";